import { memo } from 'react'

import { Text } from '@cash-me/react-components'
import NextImage from 'next/image'

import * as S from './styles'

export const SubmissionSuccess = memo(() => (
  <S.Success>
    <S.ImageWrapper>
      <NextImage
        src={process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX + '/site/substabelecido/highfive.png'}
        width={200}
        height={200}
        alt=""
        aria-hidden="true"
        sizes="200px"
      />
    </S.ImageWrapper>
    <Text size="body1" weight="medium">
      A partir de agora você passará por uma análise interna.
    </Text>
  </S.Success>
))

SubmissionSuccess.displayName = 'SubmissionSuccess'
